import * as React from "react";

import {
  LOGIN_FORM_WINDOW_EVENTS,
  PRESENTATION_SCROLL_ACTIONS,
  useJoinDrawerUserExperience,
  useOneTimePasswordUserExperience,
  usePresenterForScroll_asController,
} from "../../../Common";

export const ReactCheckout2022DrawerProvider: React.FunctionComponent = (
  props
) => {
  const { handleClose } = useJoinDrawerUserExperience();
  const { handleClose: handleCloseOTP } = useOneTimePasswordUserExperience();
  const { initiateScrollAction } = usePresenterForScroll_asController();
  const [needsToRefreshScroll, setNeedsToRefreshScroll] = React.useState(false);
  const handleLoginSuccess = React.useCallback(() => {
    handleClose();
    handleCloseOTP();
    setNeedsToRefreshScroll(true);
  }, [handleClose, setNeedsToRefreshScroll]);
  React.useEffect(() => {
    window.addEventListener(
      LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
      handleLoginSuccess
    );
    return () => {
      window.removeEventListener(
        LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
        handleLoginSuccess
      );
    };
  }, [handleLoginSuccess]);

  React.useEffect(() => {
    if (needsToRefreshScroll) {
      initiateScrollAction(PRESENTATION_SCROLL_ACTIONS.SCROLL_TO_TOP);
      setNeedsToRefreshScroll(false);
    }
  }, [needsToRefreshScroll]);

  return <React.Fragment>{props.children || []}</React.Fragment>;
};
